var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "svg-share-youtube-a",
    d: "M21.582 6.186a2.506 2.506 0 0 0-1.768-1.768C18.254 4 12 4 12 4s-6.254 0-7.814.418c-.86.23-1.538.908-1.768 1.768C2 7.746 2 12 2 12s0 4.254.418 5.814c.23.86.908 1.538 1.768 1.768C5.746 20 12 20 12 20s6.254 0 7.814-.418a2.504 2.504 0 0 0 1.768-1.768C22 16.254 22 12 22 12s0-4.254-.418-5.814ZM10 15.464V8.536L16 12l-6 3.464Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 43,
    x: 1,
    y: 1,
    stroke: "var(--svg-bg-color)",
    strokeOpacity: "var(--svg-bg-opacity)",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "svg-share-youtube-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-share-youtube-a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    mask: "url(#svg-share-youtube-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-13-13h50v50h-50Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareYoutube);
export default __webpack_public_path__ + "static/media/share-youtube.59577040769a454542e593029510c4bb.svg";
export { ForwardRef as ReactComponent };